import React, { useState } from 'react';
import './styles.scss';
import { Text } from '../../text/Text.tsx';

type CvPopupProps = {
  onClose: () => void;
};

export const CvPopup: React.FC<CvPopupProps> = ({ onClose }) => {
  const [isFull, setIsFull] = useState(false);
  const FILE_ID = "1Uf2tdiayMzJYxR8PNT0xYDDRL9DATYIv";
  const previewUrl = `https://drive.google.com/file/d/${FILE_ID}/preview`;
  const viewUrl = `https://drive.google.com/file/d/${FILE_ID}/view?usp=sharing`;

  return (
    <div
      className={`win98-popup cv-popup ${isFull ? 'full-screen' : ''}`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="popup-header">
        <Text variant="title3" style={{ color: 'white', fontWeight: 'bold' }}>
          {'CV Online - Son Dang'}
        </Text>
        <div className="header-buttons">
          <button
            className="maximize-btn"
            title="Open in new tab"
            onClick={() => window.open(viewUrl, '_blank')}
          >
            ↗
          </button>
          <button
            className="maximize-btn"
            title={isFull ? 'Restore' : 'Maximize'}
            onClick={() => setIsFull(!isFull)}
          >
            {isFull ? '❐' : '□'}
          </button>
          <button className="close-btn" title="Close" onClick={onClose}>
            ✕
          </button>
        </div>
      </div>
      <div className="popup-body cv-popup-body">
        <iframe
          className="cv-iframe"
          src={previewUrl}
          title="Son Dang CV"
          allow="autoplay"
        />
      </div>
    </div>
  );
};
